import { withInstall } from '../_util'

import Card from './Card.vue'

export default withInstall<typeof Card, {}>(Card, {})
